import React, { useState } from "react";
import { login, forgot, errMsg } from "../../services/accountApi";
import { authCss, S, Brand, PasswordField } from "./authUi";

export default function LoginPage({ onSignedIn }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (busy) return;
    if (!email.trim()) { setError("Enter your email"); return; }
    if (mode === "login" && !password) { setError("Enter your password"); return; }
    setBusy(true); setError("");
    try {
      if (mode === "login") {
        const { user } = await login(email.trim(), password, remember);
        onSignedIn && onSignedIn(user);
      } else {
        await forgot(email.trim());
        setSent(true);
      }
    } catch (err) {
      setError(errMsg(err, mode === "login" ? "Email or password is incorrect" : undefined));
    } finally { setBusy(false); }
  };

  const switchMode = (m) => { setMode(m); setError(""); setSent(false); };

  return (
    <div className="auth-wrap">
      <style>{authCss}</style>
      <form className="auth-card" onSubmit={submit} noValidate>
        <Brand heading={mode === "login" ? "Sign in" : "Reset password"} />
        <div style={S.field}>
          <label htmlFor="auth-email" style={S.label}>Email</label>
          <input
            id="auth-email" className="auth-in" type="email" name="username" autoComplete="username"
            autoFocus value={email} disabled={busy} inputMode="email" autoCapitalize="none" spellCheck={false}
            onChange={(e) => { setEmail(e.target.value); setError(""); }}
          />
        </div>
        {mode === "login" && (
          <>
            <PasswordField id="auth-pw" label="Password" value={password} autoComplete="current-password"
              disabled={busy} onChange={(v) => { setPassword(v); setError(""); }} />
            <label style={S.check}>
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)}
                style={{ width: 15, height: 15, accentColor: "var(--accent)", cursor: "pointer", margin: 0 }} />
              Remember me on this device
            </label>
          </>
        )}
        {error && <div role="alert" style={S.err}>{error}</div>}
        {sent && <div role="status" style={S.ok}>If that email has an account, a reset link is on its way.</div>}
        <button type="submit" className="auth-btn" disabled={busy || (mode === "forgot" && sent)}>
          {busy ? (mode === "login" ? "Signing in…" : "Sending…") : mode === "login" ? "Sign in" : "Send reset link"}
        </button>
        <div style={{ marginTop: 14, textAlign: "center" }}>
          {mode === "login"
            ? <button type="button" className="auth-link" onClick={() => switchMode("forgot")}>Forgot password?</button>
            : <button type="button" className="auth-link" onClick={() => switchMode("login")}>Back to sign in</button>}
        </div>
      </form>
    </div>
  );
}
